import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { LOAD_STATE } from '../../../shared/axios';
import { uuid4 } from '../../../shared/utils/uuid';

export const FETCH_INFO_REQUEST_CALLED = '@billing/center/FETCH_INFO_REQUEST_CALLED';
export const FETCH_INFO_REQUEST_SUCCEEDED = '@billing/center/FETCH_INFO_REQUEST_SUCCEEDED';
export const FETCH_INFO_REQUEST_FAILED = '@billing/center/FETCH_INFO_REQUEST_FAILED';

export const FETCH_INVOICES_REQUEST_CALLED = '@billing/center/FETCH_INVOICES_REQUEST_CALLED';
export const FETCH_INVOICES_REQUEST_SUCCEEDED = '@billing/center/FETCH_INVOICES_REQUEST_SUCCEEDED';
export const FETCH_INVOICES_REQUEST_FAILED = '@billing/center/FETCH_INVOICES_REQUEST_FAILED';

export const PLAN_UPGRADE_REQUESTED = '@billing/center/PLAN_UPGRADE_REQUESTED';
export const NEW_ADDON_SUBSCRIPTION_REQUESTED = '@billing/center/NEW_ADDON_SUBSCRIPTION_REQUESTED';
export const PAYMENT_METHOD_UPGRADE_REQUESTED = '@billing/center/PAYMENT_METHOD_UPGRADE_REQUESTED';
export const CANCEL_SUBSCRIPTION_REQUESTED = '@billing/center/CANCEL_SUBSCRIPTION_REQUESTED';

export const getBillingCenterInfo = state => state.billing.center.info;
export const getBillingCenterInvoices = state => state.billing.center.invoices;

export const fetchBillingCenterInfo = () => ({
    type: FETCH_INFO_REQUEST_CALLED,
    actionTypes: {
        success: FETCH_INFO_REQUEST_SUCCEEDED,
        fail: FETCH_INFO_REQUEST_FAILED,
    },
    payload: {},
    config: {
        url: '/api/billing/companies/billing-info',
        method: 'GET',
    },
});

export const fetchBillingCenterInvoices = (page: number, reset = false) => ({
    type: FETCH_INVOICES_REQUEST_CALLED,
    actionTypes: {
        success: FETCH_INVOICES_REQUEST_SUCCEEDED,
        fail: FETCH_INVOICES_REQUEST_FAILED,
    },
    payload: { page, reset },
    config: {
        url: '/api/billing/companies/invoices',
        method: 'GET',
        params: { page },
    },
});

export const requestUpgradePlan = (planId: string) => ({
    type: PLAN_UPGRADE_REQUESTED,
    payload: { planId },
});

export const requestNewAddonSubscription = (addonId: string) => ({
    type: NEW_ADDON_SUBSCRIPTION_REQUESTED,
    payload: { addonId },
});

export const requestUpgradePaymentMethod = () => ({
    type: PAYMENT_METHOD_UPGRADE_REQUESTED,
    payload: {},
});

export const requestCancelSubscription = () => ({
    type: CANCEL_SUBSCRIPTION_REQUESTED,
    payload: {},
});

const addInvoiceItemId = action => (
    action.payload.data.data.map(it => ({
        ...it,
        id: uuid4(),
    }))
);

function appendInvoicePageToData(state, action) {
    return [
        ...state.invoices.data.data,
        ...addInvoiceItemId(action),
    ];
}

export const billingCenterReducer = createReducer({
    [INITIAL_STATE]: {
        info: {
            data: {},
            loadState: LOAD_STATE.LOADING,
            error: null,
        },
        invoices: {
            data: {
                data: [],
                pageInfo: {
                    page: 0,
                    hasNext: true,
                    hasPrevious: false,
                },
            },
            loadState: LOAD_STATE.LOADING,
            error: null,
        },
    },
    [FETCH_INFO_REQUEST_CALLED]: state => ({
        ...state,
        info: {
            data: {},
            loadState: LOAD_STATE.LOADING,
            error: null,
        },
    }),
    [FETCH_INFO_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        info: {
            data: action.payload.data,
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        },
    }),
    [FETCH_INFO_REQUEST_FAILED]: (state, action) => ({
        ...state,
        info: {
            data: {},
            loadState: LOAD_STATE.FAIL,
            error: action.payload,
        },
    }),
    [FETCH_INVOICES_REQUEST_CALLED]: state => ({
        ...state,
        invoices: {
            ...state.invoices,
            loadState: LOAD_STATE.LOADING,
            error: null,
        },
    }),
    [FETCH_INVOICES_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        invoices: {
            data: {
                data: action.requestAction.payload.reset
                    ? addInvoiceItemId(action)
                    : appendInvoicePageToData(state, action),
                pageInfo: action.payload.data.pageInfo,
            },
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        },
    }),
    [FETCH_INVOICES_REQUEST_FAILED]: (state, action) => ({
        ...state,
        invoices: {
            ...state.invoices,
            loadState: LOAD_STATE.FAIL,
            error: action.payload,
        },
    }),
});
